import React, { useContext, useEffect, useState } from "react";
import { Tab } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { DAY_OFFICE_BOOKING_LINK } from "../../../App/configs/ListRoutes";
import { LocalizationContext } from "../../../../locales/Translation";
import UpcomingTab from "./Components/UpcomingTab";
import CompletedTab from "./Components/CompletedTab";
import CancelledTab from "./Components/CancelledTab";
import { useDispatch, useSelector } from "react-redux";
import {
  dayOfficeBookingPayloadSelector,
  refreshDayOfficeBookingSelector,
} from "../../selectors/BookingSelectors";
import { userCompanyChooseSelector } from "../../../User/selectors/UserSelectors";
import { getDayOfficeBookingListThunk } from "../../thunks/BookingThunks";
import { listDayOfficeBookingPayloadAction } from "../../actions/BookingActions";

const DayOfficeBooking = () => {
  const { translations } = useContext(LocalizationContext);
  const dispatch = useDispatch();
  const dayOfficeBookingPayload = useSelector(dayOfficeBookingPayloadSelector);
  const [loading, setLoading] = useState(false);
  const refreshDayOfficeBookingList = useSelector(
    refreshDayOfficeBookingSelector
  );
  const userCompanyChoose = useSelector(userCompanyChooseSelector);

  const _fetchListDayOfficeBooking = async () => {
    setLoading(true);
    try {
      const payload = {
        status: dayOfficeBookingPayload.status + 1,
        page: dayOfficeBookingPayload.page,
      };
      await dispatch<any>(getDayOfficeBookingListThunk(payload));
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => await _fetchListDayOfficeBooking())();
  }, [dayOfficeBookingPayload, refreshDayOfficeBookingList, userCompanyChoose]);

  const panes = [
    {
      menuItem: {
        as: Link,
        id: 1,
        to: DAY_OFFICE_BOOKING_LINK,
        content: translations.upcoming,
        key: "dayoffice-upcoming",
      },
      render: () => <UpcomingTab loading={loading} setLoading={setLoading} />,
    },
    {
      menuItem: {
        as: Link,
        id: 2,
        to: DAY_OFFICE_BOOKING_LINK,
        content: translations.completed,
        key: "dayoffice-completed",
      },
      render: () => <CompletedTab loading={loading} setLoading={setLoading} />,
    },
    {
      menuItem: {
        as: Link,
        id: 3,
        to: DAY_OFFICE_BOOKING_LINK,
        content: translations.cancelled,
        key: "dayoffice-cancelled",
      },
      render: () => <CancelledTab loading={loading} setLoading={setLoading} />,
    },
  ];

  return (
    <Tab
      menu={{ text: true }}
      activeIndex={dayOfficeBookingPayload?.status}
      onTabChange={(e, { activeIndex }: any) => {
        dispatch(
          listDayOfficeBookingPayloadAction({
            status: activeIndex,
          })
        );
      }}
      panes={panes}
      className={"tab-custom p-0"}
    />
  );
};

export default DayOfficeBooking;
